import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import styles from './styles';

// Frameworks
/** https://leafletjs.com/reference-1.6.0.html#map-overlaypane */
var defaultLeafletPaneZindex = 400;

/* Max number of features rendered as React element in leaflet vector layer  */
var maxFeaturesAsReactElement = 100;

// Projections
var projDefinitions = {
  epsg5514: '+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs'
};
export default _objectSpread({
  maxFeaturesAsReactElement: maxFeaturesAsReactElement,
  defaultLeafletPaneZindex: defaultLeafletPaneZindex,
  projDefinitions: projDefinitions
}, styles);